import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation("common");
  return (
    <div>
      <div className="container-fluid">
        <div className="container">
          <div className="footer bagf">
            <div className="social_media">
              
              <p>{t("@2026 SensCare. All Rights Reserved.")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
